import styled from 'styled-components'

const CouponUi = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`

export default CouponUi
